<template>
  <div class="content">
    <div class="center flex-row">
      <div class="detail-box">
        <div class="device-box flex-row">
          <div class="device-img">
           <div style="height:2.96rem;position: relative">
             <img loading="lazy" :src="info.pictureUrl ? $imgUrl + info.pictureUrl : require('../../assets/image/login/logo.png')" alt="" class="img_2">
           </div>

            <!--            <img loading="lazy" :src="$imgUrl + info.pictureUrl"/>-->
          </div>
          <div class="device-info">
            <p class="name">{{ info.name }}</p>
            <!--						<div class="price-box flex-row">-->
            <!--							<span>价格</span>-->
            <!--							<span class="price">￥{{info.price}}</span>-->
            <!--							&lt;!&ndash; <div class="more" @click="moreShow = !moreShow">更多<em></em></div>-->
            <!--							<span class="month-sale">月销量：{{'0'}}</span>-->
            <!--							<div v-show="moreShow" class="more-list flex-row">-->
            <!--								<div :class="['item',{'active':termNum==index}]" v-for="(item,index) in termList"-->
            <!--									@click="termNum=index">-->
            <!--									<p>{{item.month}}</p>-->
            <!--									<p>￥{{item.price}}</p>-->
            <!--									<em></em>-->
            <!--								</div>-->
            <!--							</div> &ndash;&gt;-->
            <!--						</div>-->

            <div class="info">
              <div class="title">
                <p>设备信息</p>
              </div>
              <div class="info-intro flex-row">
                <div class="item"><label>厂商名称</label> <span>{{ info.customerName }}</span></div>
                  <div class="item" ><label>设备类型</label> <span>{{ typeName }}</span></div>
                  <div class="item" v-if="info.serviceDictValue == 0"><label>设备容量</label> <span>{{ volume }}</span></div>
                <!--								<div class="item"> <label>设备地点</label>-->
                <!--									<span>{{info.provinceName + info.cityName + info.countyName}}</span>-->
                <!--								</div>-->
<!--                <div class="item" v-if="info.serviceDictValue == 0"><label>输出电压</label> <span>{{ voltage }}</span></div>-->
<!--                <div class="item" v-if="info.serviceDictValue !== 0"><label>设备型号</label> <span>{{ lightValue }}</span></div>-->
                <div class="item" v-if="info.serviceDictValue !== 0"><label>设备型号</label> <span>{{ info.lightingTypeLabel }}</span></div>
                <div class="item"><label>销量</label> <span>{{ info.num || '暂无'}}</span></div>
                <div class="item">
                  <label>{{ info.serviceDictValue === 0 ? '台班费' : '单价' }}</label> <span>{{ info.price || '暂无'}}</span></div>
                <div class="item" style="display: flex;">
                  <label>评分</label>
<!--                  <span>{{ info.satisfactionRating || '暂无'}}</span>-->
                  <el-rate v-model="info.satisfactionRating" disabled show-score text-color="#ff9900" score-template=""/>
                  <span v-if="info.satisfactionRating === null" style="color: #ff9900;">未评分</span>
                  <span v-else style="color: #ff9900; font-weight: bold;">{{ info.satisfactionRating }} 分</span>
                </div>
                <div class="item" style="width: 100%;display: flex"><label>简介</label> <span>{{info.conment}}</span></div>
              </div>
            </div>
            <div class="bot flex-row justify-between">
              <!--							<div class="btns flex-row" v-if="changeEq == 0">-->
              <!--								<button class="apply" @click="applyHandle">申请服务</button>-->
              <!--								<button class="service" @click="openCustomerServer">在线留言</button>-->
              <!--							</div>-->
              <!--							<div class="btns flex-row" v-if="changeEq != 0">-->
              <!--								<button class="apply" @click="saveChangeOrderEq">确定</button>-->
              <!--							</div>-->


              <div v-if="info.shoppingTrolley" class="collect flex-row" @click="deladdEquipment">
                <img src="../../assets/image/collected.png"/>
                <span>已加入</span>
              </div>
              <div class="collect flex-row" @click="addEquipment" v-else>
                <!--								<img src="../../assets/image/collect.png" />-->
                <span>加入收藏</span>
                <!--								<span>加入列表</span>-->
              </div>
            </div>
          </div>
        </div>

        <!--				<div class="intro-box">-->
        <!--					<div class="title-box flex-row justify-between">-->
        <!--						<div class="nav-box">-->
        <!--							<span :class="  {active: activeNum==index}" v-for="(item,index) in navList"-->
        <!--								@click="activeNum=index">{{item}}</span>-->
        <!--						</div>-->
        <!--						<div class="right flex-row">-->
        <!--							<span-->
        <!--								style="font-size: 14px;color: #8B8B8B;margin-right: 10px;">{{info.fraction == 0 ? '暂无评分' : '综合评分'}}</span>-->
        <!--							<el-rate v-if="info.fraction != 0" v-model="info.fraction > 5 ? 5 : info.fraction" :max="5"-->
        <!--								disabled show-score text-color="#ff9900" score-template="{value}">-->
        <!--							</el-rate>-->
        <!--						</div>-->
        <!--					</div>-->
        <!--					&lt;!&ndash; 服务方案 &ndash;&gt;-->
        <!--					<div class="service-plan flex-row" v-if="activeNum == 0">-->
        <!--						<div class="item"> <label>架空线路：</label>-->
        <!--							<span>{{info.priceGears && info.priceGears.jkxl}}元/档</span>-->
        <!--						</div>-->
        <!--						<div class="item"> <label>电缆线路：</label>-->
        <!--							<span>{{info.priceGears && info.priceGears.dlxl}}元/米</span>-->
        <!--						</div>-->
        <!--						<div class="item"> <label>单杆：</label>-->
        <!--							<span>{{info.priceGears && info.priceGears.dgxl}}元/米</span>-->
        <!--						</div>-->
        <!--						<div class="" style="margin: 10px 30px;color: #8B8B8B;">-->
        <!--							标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调-->
        <!--						</div>-->
        <!--					</div>-->
        <!--					&lt;!&ndash; 公司介绍 &ndash;&gt;-->
        <!--					<div class="service-plan flex-row gongsi" v-if="activeNum == 1">-->
        <!--						<div class="left">-->
        <!--							<img :src="$imgUrl + (info.companyUrl || '/profile/upload/2022/06/24/12_20220624111743A024.png')"-->
        <!--								alt="">-->
        <!--							<span>{{info.companyName}}</span>-->
        <!--						</div>-->
        <!--						<div class="right">-->
        <!--							<span>公司介绍:</span>-->
        <!--							<span>{{info.companyIntroduce}}</span>-->
        <!--						</div>-->
        <!--					</div>-->
        <!--					&lt;!&ndash; 公司资质 &ndash;&gt;-->
        <!--					<div class="service-plan flex-row" v-if="activeNum == 2">-->
        <!--						<el-image style="width: 400px;height: 200px;padding: 20px"-->
        <!--							:src="$imgUrl + info.tradingCertificate"-->
        <!--							:preview-src-list="[$imgUrl + info.tradingCertificate]" />-->

        <!--					</div>-->
        <!--					&lt;!&ndash; 备选用电服务 &ndash;&gt;-->
        <!--					<div class="env-list-box" v-if="activeNum == 3">-->
        <!--						<div class="item" v-for="(item,index) in envList" :key="index"-->
        <!--							@click="jump1(item.id,item.serviceType)">-->
        <!--							<img :src="$imgUrl +item.pictureUrl" alt="">-->
        <!--							<div style="font-weight: 600;display: flex;align-items: center;text-align: center;height: 48px;">-->
        <!--								{{item.title}}-->
        <!--							</div>-->
        <!--							<span-->
        <!--								style="color: gray;margin-left: 10px;"><a>电压：{{item.voltage}}</a>容量：{{item.volume}}</a></span>-->
        <!--							<span style="font-size: 16px;color:red">￥-->
        <!--								{{info.priceGears ? info.priceGears.price : '0.00'}} /月</span>-->
        <!--						</div>-->
        <!--					</div>-->
        <!--					&lt;!&ndash; 用户评价 &ndash;&gt;-->
        <!--					<div class="coment-intro flex-row" v-if="activeNum == 4">-->
        <!--						<CommentList :commentList="info.commentDtoList"></CommentList>-->
        <!--					</div>-->
        <!--				</div>-->
        <div class="intro-box">
          <div class="title-box flex-row justify-between">
            <div class="nav-box">
        							<span >公司介绍</span>
            </div>
<!--            <div class="right flex-row">-->
<!--                      <el-rate v-if="info.fraction != 0" v-model="info.fraction > 5 ? 5 : info.fraction" :max="5"-->
<!--                       disabled show-score text-color="#ff9900" score-template="{value}">-->
<!--              </el-rate>-->
<!--            </div>-->
          </div>

          <!-- 公司介绍 -->
          <div class="service-plan flex-row gongsi" >
            <div class="left" style="width: 20%;">
<!--              <img :src="$imgUrl + (info.heading || '/profile/upload/2022/06/24/12_20220624111743A024.png')" alt="">-->
              <img :src="info.heading ? $imgUrl + info.heading : require('../../assets/image/暂无图片.png')"
                   @error="$event.target.src = require('../../assets/image/暂无图片.png')"
                   alt="">
<!--              <span>{{info.companyName}}</span>-->
            </div>
            <div class="right" style="width: 70%;">
<!--              <span>公司介绍:</span>-->
              <span>{{info.companyIntroduce}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="recommend-box">
        <div class="recommend">
          <p class="title">该公司设备推荐</p>
          <div class="rec-list">
            <div v-for="(item,i) in recommendCompanyList" :key="i" class="rec-item" @click="jump(item)">
              <RelatedCompany :detail="item"></RelatedCompany>
            </div>
          </div>
        </div>
      </div>
      <loginDia
          :dialogShow.sync="dialogShow"
      ></loginDia>
    </div>
  </div>
</template>

<script>
import RelatedCompany from '@/components/ordinary/relatedCompany.vue'
import CommentList from '@/components/commentList.vue'
import {deleteGoodApi} from "@/http/api/ordinary";
import {
  equipmentDetailApi,
  equipmentListApi,
  addEquipmentApi,
   getDicts,
} from '../../http/api/ordinary.js'
import {
  updateOrder,
  updateOrderEq
} from '../../http/factory/add-eme.js'
import loginDia from "@/components/ordinary/loginDia.vue";
import {getDictByType} from "@/utils/dictUtils";

export default {
  components: {
    loginDia,
    RelatedCompany,
    CommentList
  },
  data() {
    return {
      info: {},
      dialogShow: false,
      moreShow: false,
      activeNum: 0,
      navList: ['配套线路', '公司介绍', '公司资质', '备选用电服务', '用户评价'],
      termNum: 0,
      termList: [{
        month: '3月',
        price: '20000'
      }, {
        month: '6月',
        price: '40000'
      }, {
        month: '9月',
        price: '50000'
      }, {
        month: '12月',
        price: '80000'
      }],
      //相似公司
      recommendCompanyList: [],
      envList: [],
      changeEq: 0,
      voltage: '',
      lightValue:'',
      volume: '',
      typeName: '',
      query: {
        serviceDictValue: 0,
        pageSize: 5,
        pageNum: 1,
        customerName: '',
      },
    };
  },
  created() {
    this.getDetail()

    this.changeEq = this.$route.query.changeEq
    console.log(this.$route.query)
  },

  watch: {
    '$route.query.id'(newId, oldId) {
      // 确保路由真正发生了变化（避免同一路由重复触发）
      if (newId && newId !== oldId) {
        this.$router.go(0) // 使用路由刷新
      }
    }
  },
  methods: {
    dict() {
      getDictByType(
          'voltage_kv'
      ).then(res => {
        let voltageDictValue = this.info.voltageDictValue
        if (voltageDictValue)
          this.voltage = res.find(item => item.dictValue === voltageDictValue).dictLabel
      })


      /*//设备型号不再使用 字典
      getDictByType(
          'lighting_type'
      ).then(res => {
        let lightingTypeValue = this.info.lightingTypeValue
        if (lightingTypeValue)
          this.lightValue = res.find(item => item.dictValue === lightingTypeValue).dictLabel
      })
      */

      getDictByType('volume_kva').then(res => {
        // console.log(111,res)
        let volumeDictValue = this.info.volumeDictValue
        if (volumeDictValue)
          this.volume = res.find(item => item.dictValue === volumeDictValue).dictLabel
      })

      getDictByType('facility_type').then(res => {
        let facilityTypeDictValue = this.info.facilityTypeDictValue
        if (facilityTypeDictValue)
          this.typeName = res.find(item => item.dictValue === facilityTypeDictValue).dictLabel
      })

    },

    updataNum(val) {

      addEquipmentApi({
        id: this.info.shoppingTrolley.id,
        number: this.info.shoppingTrolley.number
      }).then(res => {

      })
    },


    addEquipment() {
      if (!this.$store.state.token) {
        this.dialogShow = true
        return
      }
      addEquipmentApi({
        archiveId: this.info.id,
        number: 1
      }).then(res => {
        this.$message({
          message: '当前设备已加入设备列表',
          type: 'success'
        });
        this.getDetail()
      })

    },
    deladdEquipment() {
      // console.log(this.info.shoppingTrolley.id)
      deleteGoodApi(
          this.info.shoppingTrolley.id
      ).then(res => {
        this.$message({
          type: 'success',
          message: '设备移除成功'
        })
        this.getDetail()
      })
    },
    saveChangeOrderEq() {
      updateOrderEq({
        id: this.changeEq,
        equipmentId: this.info.id
      }).then(res => {
        this.$message({
          message: '设备修改成功',
          type: 'success'
        });
        this.$router.push({
          path: '/ordinaryUser/rentApply',
          query: {
            orderId: this.changeEq
          }
        })
      })
    },
    getDetail() {
      equipmentDetailApi(
          this.$route.query.id
      ).then(res => {
        this.info = res
        this.query.serviceDictValue = res.serviceDictValue
        this.query.customerName = res.customerName
        // beixuanApi({
        // 	customerId: this.info.customerId,
        // 	id: this.$route.query.id,
        // 	serviceType: 0,
        // 	pageSize: 8
        // }).then(res => {
        // 	this.envList = res.data
        //
        // })

        this.dict()
        this.getRecommendCompanyList()
      })
    },
    openCustomerServer() {
      this.$router.push({
        path: '/service',
        query: {
          contactType: 1,
          contactId: this.info.customerId
        }
      })
    },
    getRecommendCompanyList() {


      equipmentListApi(this.query).then((res) => {
        this.recommendCompanyList = res.rows;

        console.log(this.recommendCompanyList)
      });


      // recommendCompanyListApi({
      // 	pageNum: 8,
      // 	meGetId: this.info.customerId
      // }).then(res => {
      // 	console.log(res)
      // 	this.recommendCompanyList = res
      // })
    },

    jump(id) {
      this.$router.push({
        path: '/ordinaryUser/rentDetail',
        query: {
          id: id.id,
        }
      })
      this.$router.go(0) // 使用路由刷新
    }
  }
}
</script>

<style scoped lang="less">
// 公司介绍
.gongsi {
  .left {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 100px;
      height: 100px;
    }

    span {
      margin-top: 10px;
    }
  }

  .right {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    //span {
    //  font-size: 16px;
    //  margin-bottom: 10px;
    //}
    //
    //span:nth-child(1) {
    //  font-size: 18px;
    //  font-weight: 600;
    //}
  }

}

// 其他方案
.env-list-box {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  min-height: 480px;

  .item {
    width: 25%;
    height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      box-sizing: border-box;
      padding: 0 20px;
      width: 100%;
      height: 200px;
    }

    span {
      margin-top: 10px;
    }
  }
}


.content {
  font-size: .14rem;
  background: #F5F5F5;

  .center {
    width: 16.88rem;
    margin: 0 auto;
    padding: 0.2rem 0;

    button {
      outline: none;
      cursor: pointer;
    }
  }

  .detail-box {
    flex: 1;
    background: #FFFFFF;
    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
    margin-right: .21rem;
    padding: .25rem .3rem;

    .device-box {
      .device-img {
        width: 2.96rem;
        height: 2.96rem;
        border-radius: 0.06rem;
        margin-right: .2rem;

        img {

          //max-width: 100%;
          //max-height: 400px; /* 最大高度限制 */
          //width: auto;
          //height: auto;
          //display: block;
          //margin: 0 auto;

          max-width: 100%;
          max-height: 2.96rem;
          width: auto;
          height: auto;
          display: block;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          border-radius: 0.06rem;
        }
      }

      .device-info {
        flex: 1;

        .name {
          font-size: .2rem;
          color: #333333;
          line-height: .23rem;
          font-weight: 500;
        }

        .price-box {
          margin-top: .22rem;
          font-size: .14rem;
          color: #000000;
          line-height: .2rem;
          align-items: center;
          position: relative;

          .price {
            color: #FF4141;
            margin-left: .1rem;
          }

          .more {
            width: .62rem;
            height: .2rem;
            background: #FFFFFF;
            border-radius: .02rem;
            opacity: 1;
            border: 1px solid rgba(193, 193, 193, 0.31);
            font-size: .12rem;
            color: #FF8B36;
            line-height: .2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: .06rem;
            cursor: pointer;

            em {
              display: block;
              width: 0;
              height: 0;
              border-top: 4px solid #FF8B36;
              border-right: 4px solid transparent;
              border-left: 4px solid transparent;
            }
          }

          .month-sale {
            color: #333333;
            margin-left: .38rem;
            position: relative;

            &::after {
              content: '';
              width: 1px;
              height: .08rem;
              border-left: 1px solid #E3E3E3;
              position: absolute;
              left: -0.19rem;
              top: 0.07rem;
            }
          }

          .more-list {
            width: 4.25rem;
            background: #FFFFFF;
            box-shadow: 0px .03rem .04rem 1px rgba(95, 95, 95, 0.11);
            border-radius: .04rem;
            border: 1px solid #ECECEC;
            flex-wrap: wrap;
            padding: .06rem 0 .22rem .22rem;
            position: absolute;
            left: 0;
            top: .3rem;
            z-index: 8;

            .item {
              margin-top: .16rem;
              width: .74rem;
              height: .57rem;
              background: #FFFFFF;
              border-radius: .04rem;
              border: 1px solid #E7E7E7;
              margin-right: .2rem;
              padding: .15rem .2rem;
              position: relative;
              overflow: hidden;

              p {
                font-size: .13rem;
                color: #B3B3B3;
                line-height: .2rem;
              }

              p:nth-of-type(2) {
                margin-top: .15rem;
              }

              &.active {
                background: #FFF5EF;
                border: 1px solid #FEC4A2;

                p {
                  color: #FF8E4F;
                }

                em {
                  display: block;
                  position: absolute;
                  right: -.24rem;
                  bottom: -.24rem;

                  &:before {
                    content: "";
                    width: .48rem;
                    height: .48rem;
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    background-color: #FF8E4F;
                    border-radius: 50%;
                  }

                  &:after {
                    content: "";
                    width: 0.05rem;
                    height: 0.1rem;
                    position: absolute;
                    left: -0.36rem;
                    bottom: .3rem;
                    border: 1px solid #fff;
                    border-top-color: transparent;
                    border-left-color: transparent;
                    transform: rotate(45deg);
                    z-index: 10;
                  }
                }
              }
            }
          }
        }

        .tips {
          font-size: .13rem;
          color: #8F8F8F;
          line-height: .33rem;
          margin-top: .1rem;
        }

        .info {
          width: 100%;
          border-radius: .06rem;
          opacity: 1;
          border: 1px solid #F2F2F2;
          margin-top: .16rem;

          .title {
            height: .44rem;
            background: #FFF3EC;
            padding: 0 .24rem;

            p {
              font-size: .16rem;
              color: #000000;
              line-height: .44rem;
              position: relative;

              &::after {
                content: '';
                width: .04rem;
                height: .14rem;
                background: #FF5400;
                position: absolute;
                top: .14rem;
                left: -0.1rem;
              }
            }
          }

          .info-intro {
            flex-wrap: wrap;
            padding: .1rem 0;
            background-color: #FFFDFC;

            .item {
              width: calc(50% - .4rem);
              line-height: 0;
              padding: .15rem .2rem;

              label {
                display: inline-block;
                min-width: .9rem;
                font-size: .14rem;
                line-height: .24rem;
                color: #AAAAAA;
                margin-right: .2rem;
                text-align: right;
              }

              span {
                font-size: .14rem;
                line-height: .24rem;
                color: #333333;
              }
            }
          }


        }

        .bot {
          margin-top: .24rem;

          .btns {
            .apply {
              width: 1.07rem;
              height: .42rem;
              background: #FA6600;
              border-radius: .06rem;
              font-size: .14rem;
              color: #FFFFFF;
              line-height: .42rem;
              text-align: center;
              border: none;
            }

            .service {
              width: 1.07rem;
              height: .42rem;
              background: #FFFFFF;
              border-radius: .06rem;
              border: 1px solid #FA6600;
              font-size: .14rem;
              color: #FA6600;
              line-height: .42rem;
              text-align: center;
              margin-left: .2rem;
            }
          }

          .collect {
            align-items: center;
            cursor: pointer;

            img {
              width: 22px;
              height: 22px;
              margin-right: 10px;
            }

            span {
              font-size: .14rem;
              color: #818181;
              line-height: .4rem;
            }
          }
        }
      }
    }

    .intro-box {
      margin-top: .63rem;
      background: #FFFFFF;
      border-radius: .06rem;
      border: 1px solid #E9E9E9;
      //min-height: 620px;
      overflow-y: auto;

      .title-box {
        min-height: .52rem;
        background: #F4F4F4;
        border-radius: .05rem .05rem 0px 0px;

        .nav-box {
          padding: 0 .17rem;

          span {
            display: inline-block;
            margin: 0 .25rem;
            font-size: .14rem;
            line-height: .52rem;
            color: #000000;
            position: relative;
            cursor: pointer;

            &.active {
              color: #FA6600;
            }

            &.active::after {
              content: '';
              width: 100%;
              height: .04rem;
              background: #FA6600;
              border-radius: .05rem;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }

        .right {
          height: .52rem;
          padding: 0 .2rem;
          border-top: 1px dashed #F3F3F3;
          align-items: center;

          .card-text_3 {
            font-size: .13rem;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #8B8B8B;
            line-height: .18rem;
            margin-right: .09rem;
            white-space: nowrap;
          }

          .xingxing {
            width: .15rem;
            height: .15rem;
            margin-right: .06rem;
            background: url('../../assets/image/star_2.png') no-repeat;
            background-size: 100% 100%;

            &.active {
              background: url('../../assets/image/star_1.png') no-repeat;
              background-size: 100% 100%;
            }
          }

          .text-score {
            font-size: .13rem;
            font-family: PingFang SC-Regular, PingFang SC;
            color: #FF7E36;
            line-height: .18rem;
            margin-left: .04rem;
          }
        }
      }

      // .service-plan {
      // 	flex-wrap: wrap;
      // 	padding: .1rem 0;
      // 	min-height: 100px;

      // 	.item {
      // 		width: calc(33.33% - .4rem);
      // 		line-height: 0;
      // 		padding: .15rem .2rem;

      // 		label {
      // 			display: inline-block;
      // 			min-width: .9rem;
      // 			font-size: .14rem;
      // 			line-height: .24rem;
      // 			color: #AAAAAA;
      // 			margin-right: .2rem;
      // 			text-align: right;
      // 		}

      // 		span {
      // 			font-size: .14rem;
      // 			line-height: .24rem;
      // 			color: #333333;
      // 		}
      // 	}
      // }
      .service-plan {
        margin-top: .22rem;
        flex-wrap: wrap;
        padding: .15rem 0 .3rem;
        background: #F9F9F9;
        border-radius: .06rem;
        align-items: center;

        .item {
          width: 20%;
          line-height: 0;
          padding: .15rem .2rem;

          label {
            display: inline-block;
            min-width: .9rem;
            font-size: .14rem;
            line-height: .24rem;
            color: #AAAAAA;
            margin-right: .2rem;
            text-align: right;
          }

          span {
            font-size: .14rem;
            line-height: .24rem;
            color: #333333;
          }
        }
      }
    }

    .coment-intro {
      padding: .3rem .2rem;
      min-height: 100px;
      max-height: 400px;
      overflow-y: auto;
    }
  }

  .recommend-box {
    width: 4.87rem;

    .recommend {
      padding: 0.2rem 0.27rem;
      background: #FFFFFF;
      border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;

      .title {
        font-size: 0.14rem;
        color: #000000;
        line-height: 1;
        padding-bottom: 0.06rem;
      }

      .rec-list {
        .rec-item {
          padding: .24rem 0;
          border-bottom: 1px solid #EFEFEF;
        }

        .rec-item:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
